// config.js
export const urlBase = 'https://pelikan-app.herokuapp.com';
// export const urlBase = 'http://localhost:8080';

export const urlLogin = `${urlBase}/api/auth/login`;
export const urlClients = `${urlBase}/clients`;
export const urlAccountants = `${urlBase}/accountants`;
export const urlSupervisors = `${urlBase}/supervisors`;
export const urlAccountingStatements = `${urlBase}/accountingStatements`;
export const urlAccountingSettlement = `${urlBase}/accountingSettlement`;
export const urlTariffs = `${urlBase}/tariff`;
export const urlDocumentType = `${urlBase}/documentType`;
export const urlServiceType = `${urlBase}/serviceType`;
export const urlAccountingApps = `${urlBase}/accountingApp`;
export const urlLegalForms = `${urlBase}/legalForms`;
export const urlContactRoles = `${urlBase}/contactRoles`;
export const urlClientTariff = `${urlBase}/clientTariff`;
export const urlClientPackage = `${urlBase}/clientPackage`;
export const urlReasonForTerminatingCooperation = `${urlBase}/reasonForTerminatingCooperation`;
export const urlUsers = `${urlBase}/users`;
export const urlOverview = `${urlBase}/overview`;
export const urlLogActivity = `${urlBase}/activityLog`;
export const urlFiles = `${urlBase}/files`;
export const urlLivespace = `${urlBase}/livespace`;
export const urlAdditionalCosts = `${urlBase}/additionalCosts`;
export const urlAccountantFinancialStatementInvoices = `${urlBase}/accountant-financial-statement-invoices`;

export const urlInvoiceFakturownia = `${urlBase}/fakturownia/createInvoice`;
export const urlClientsFakturownia = `${urlBase}/fakturownia/getClient`;
export const urlFakturownia = `${urlBase}/fakturownia`;
export const urlImports = `${urlBase}/import`;
export const urlNotifications = `${urlBase}/notification`;
export const urlClientSurvey = `${urlBase}/clientSurvey`;
export const urlScanye = `${urlBase}/scanye`;
export const urlCache = `${urlBase}/cache`;
export const urlFizen = `${urlBase}/api/fizen/link`